var _excluded = ["selectValue", "valueRightElement", "onFocus", "onBlur", "size", "isDisabled", "isReadOnly", "isViewMode", "selectedOption", "hasSections", "leftElement", "rightElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useState } from 'react';
import { useTestId } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Text } from '../../../dataDisplay';
import { TextField } from '../../../selectionAndInputs';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var InputComponent = (_ref, ref) => {
  var _selectedOption$label;

  var {
    selectValue,
    valueRightElement,
    onFocus: _onFocus,
    onBlur: _onBlur,
    size,
    isDisabled,
    isReadOnly,
    isViewMode,
    selectedOption,
    hasSections,
    leftElement,
    rightElement
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var getTestId = useTestId('base-select');
  var [valueRightElementWidth, setValueRightElementWidth] = useState(0);
  var valueRightElementRef = useCallback(el => {
    if (!el) return;
    setValueRightElementWidth(el.offsetWidth);
  }, []);
  var [isFocused, setIsFocused] = useState(false);
  var [showInputOverlay, setShowInputOverlay] = useState(false);
  var styles = useMultiStyleConfig('BaseSelect', {
    hasLeftElement: Boolean(leftElement),
    size,
    isViewMode,
    // Passing `valueRightElementWidth` only when overlay is visible so that we can type until the end of the input.
    valueRightElementWidth: showInputOverlay ? valueRightElementWidth : 0
  });
  useEffect(() => {
    var _selectedOption$avata;

    var hasValue = Boolean(selectedOption) || Boolean(selectValue);
    var hasRightElement = hasSections || Boolean(selectedOption === null || selectedOption === void 0 ? void 0 : (_selectedOption$avata = selectedOption.avatarProps) === null || _selectedOption$avata === void 0 ? void 0 : _selectedOption$avata.badge) || Boolean(valueRightElement);
    setShowInputOverlay(hasRightElement && hasValue && !isFocused);
  }, [hasSections, selectedOption, valueRightElement, selectValue, isFocused]);
  var inputOverlayValue = (_selectedOption$label = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _selectedOption$label !== void 0 ? _selectedOption$label : selectValue;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread(_objectSpread({
      "data-component": "BaseSelect.Input",
      ref: ref,
      sx: styles['trigger']
    }, getTestId('input')), props), {}, {
      onFocus: e => {
        setIsFocused(true);
        _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(e);
      },
      onBlur: e => {
        setIsFocused(false);
        _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(e);
      },
      size: size,
      isDisabled: isDisabled,
      isReadOnly: isReadOnly,
      isViewMode: isViewMode,
      leftElement: leftElement,
      rightElement: rightElement
    })), showInputOverlay && /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
      __css: styles['triggerOverlay'],
      "data-disabled": isDisabled || null,
      "data-readonly": isReadOnly || null,
      "data-view-mode": isViewMode || null
    }, getTestId('input', 'overlay')), {}, {
      children: [inputOverlayValue && /*#__PURE__*/_jsx(Text, {
        textStyle: "inline",
        color: "inherit",
        shouldSupportEllipsis: true,
        children: inputOverlayValue
      }), valueRightElement && /*#__PURE__*/_jsx(Box, {
        ref: valueRightElementRef,
        __css: styles['valueRightElement'],
        children: valueRightElement
      })]
    }))]
  });
};

export var Input = /*#__PURE__*/React.forwardRef(InputComponent);
Input.displayName = 'BaseSelect.Input';
//# sourceMappingURL=Input.js.map